import { Table } from "Components";
import { getReferralList } from "Redux/Actions/user";
import { IMAGES } from "Shared/Images";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { indexHistory } from "Shared/Constants";

const ReferralList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const headings = [t("no"), t("username"), t("total-bet"), t("total-win"), t("win-lose")];
  const [totalCount, setTotalCount] = useState([]);
  const [data, setData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchRecords = ({ selected }) => {
    let payload = {
      limit: 10,
      skip: selected,
    };
    setCurrentIndex(selected);
    dispatch(
      getReferralList(payload, (response) => {
        setData(response?.data?.referrals);
        setTotalCount(response?.data?.totalCount);
      })
    );
  };

  useEffect(() => {
    let payload = {
      limit: 10,
      skip: 0,
    };
    dispatch(
      getReferralList(payload, (response) => {
        setData(response?.data?.referrals);
        setTotalCount(response?.data?.totalCount);
      })
    );
  }, []);

  return (
    <div className="w-100 form_front pt-4">
      <div className="W-100 form_card bg-white text-start text-dark p-4">
        <>
          {data?.length ? (
            <>
              <div className="table-responsive">
                <Table className="table text-dark" headings={headings}>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                      <td>{indexHistory(currentIndex, 10) + index}</td>
                        <td>{item?.userName}</td>
                        <td>{item?.totalBet ? item?.totalBet?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</td>
                        <td>{item?.totalWin ? item?.totalWin?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</td>
                        <td className={item?.winLose < 0 ? "text-danger" : item?.winLose == 0 ? "" : "text-success"}>{item?.winLose ? item?.winLose?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <ReactPaginate
                previousLabel="<<"
                nextLabel=">>"
                breakLabel="..."
                pageCount={Math.ceil(totalCount / 10)}
                marginPagesDisplayed={3}
                onPageChange={fetchRecords}
                containerClassName="pagination justify-content-center mt-4"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLinkClassName="page-link"
                breakClassName="page-item"
                activeClassName="active"
              />
            </>
          ) : (
            <div className="p-5 d-flex flex-column justify-content-center text-center no-result">
              <em><img src={IMAGES.empty} alt="" width="44" /></em>
              <span className="h5 mt-3">{t("no-trans")}</span>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default ReferralList;
